import $ from 'jquery';

const sub = {
	networkToggle: () => {
		// 국내 및 해외 모바일에서 토글버튼
		const button = $('.network_item .more_map');
		button.on('click', function () {
			const item = $(this).closest('.network_item');
			if (item.hasClass('active')) {
				item.removeClass('active');
			} else {
				item.addClass('active');
			}
		});

		// 해외 레이어팝업
		const layerButton = $('.overseas_button');
		layerButton.on('click', function () {
			const index = $(this).data('index');
			console.log(index);
			$('.network_overseas').addClass('active').find(`#overseas_${index}`).addClass('active');
		});

		const layerClose = $('.network_item .close');
		layerClose.on('click', function () {
			$('.network_overseas').removeClass('active').find('.network_item').removeClass('active');
		});
	},

	// 해외네트워크 지도 클릭
	networkOverseas: () => {
		const button = $('.overseas_map_item');
		button.on('click', function () {
			const name = $(this).data('name');
			const target = $(`.network_overseas .network_item[data-name='${name}']`);
			const top = target.offset().top - 64;
			$('html').animate({ scrollTop: top }, 500);
			if (!target.hasClass('active')) target.find('.more_map').trigger('click');
		});
	},

	toggleBtn: () => {
		const investToggle = $('.invest .box_btn');
		investToggle.on('click', function (e) {
			$(e.target).toggleClass('on');
			const boxList = $(e.target).closest('.box').find('.box_list');
			boxList.toggleClass('on');
			if (boxList.hasClass('on')) {
				boxList.css('height', boxList.get(0).scrollHeight + 'px'); // 내용 높이로 확장
			} else {
				boxList.css('height', '0'); // 높이 0으로 축소
			}
		});
	},

	passwordToggle: () => {
		$('.toggle-password').on('click', function () {
			const $passwordInput = $('#passwordInput');
			const $passwordInput2 = $('#passwordInput2');
			const isPasswordVisible = $passwordInput.attr('type') === 'text';

			if (isPasswordVisible) {
				$passwordInput.attr('type', 'password');
				$passwordInput2.attr('type', 'password');
				$(this).removeClass('active');
			} else {
				$passwordInput.attr('type', 'text');
				$passwordInput2.attr('type', 'text');
				$(this).addClass('active');
			}
		});
	},

	fileUpload: () => {
		$('.file').on('change', function () {
			const fileName = $(this)[0].files[0]?.name || '';
			$('#fileName').val(fileName);
		});
	},

	emailSelect: () => {
		$('#emailSelect').on('change', function () {
			const selectedValue = $(this).val();
			const $domain = $('#domain');

			if (selectedValue === 'custom') {
				$domain.val('');
				$domain.prop('disabled', false);
			} else {
				$domain.val(selectedValue);
				$domain.prop('disabled', true);
			}
		});
	},

	// 공통 탭
	tabNav: () => {
		const tab = $('.tab-nav > li');
		tab.on('click', function () {
			const index = $(this).index();
			$('.tab-nav li').removeClass('on');
			$('.tab-contents').removeClass('on').css({
				opacity: 0,
				visibility: 'hidden',
			});

			// 클릭된 탭과 해당 콘텐츠에 active 클래스 추가
			$(this).addClass('on');
			$('.tab-contents')
				.eq(index)
				.addClass('on')
				.css({
					visibility: 'visible',
				})
				.animate({ opacity: 1 }, 300); // 부드러운 opacity 전환
		});
	},

	accordion: () => {
		// 아코디언 공통
		const accordion = $('.accordion .item');
		accordion.on('click', function () {
			const item = $(this);
			if (item.hasClass('active')) {
				item.removeClass('active');
			} else {
				item.addClass('active');
			}
		});
	},

	video: () => {
		// 유튜브 재생
		const $popup = $('.popup.youtube');
		const $iframe = $popup.find('iframe');

		$('.social_youtube_box li').on('click', function (e) {
			// no_contents 클래스가 있는 경우 클릭 막기
			if ($(this).hasClass('no_contents')) {
				e.preventDefault(); // 기본 동작 막기
				return; // 함수 종료
			}

			e.preventDefault();
			const videoUrl = $(this).data('video-url') + '?rel=0&playsinline=1&autoplay=1';
			$iframe.attr('src', videoUrl);
			$popup.addClass('active');
		});

		$popup.find('.layer_mask').on('click', function () {
			$popup.removeClass('active');
			setTimeout(() => $iframe.attr('src', ''), 200);
		});
	},

	copperScroll: () => {
		// 고려아연만의 경쟁력 스크롤 부분

		// .draggle-wrap 있을때 실행
		if ($('.draggle-wrap').length > 0) {
			let isOn = false; // 상태 플래그 (on 클래스의 상태 관리)
			let scrolledDistance = 0;

			const title = $('.draggle-wrap .left .title'); // circle 안 바뀌는 곳
			const left = $('.draggle-wrap .left'); // 다이어그램 요소
			const right = $('.draggle-wrap .right div'); // 다이어그램 요소
			const top = $('.scroll-top'); // 스크롤 이벤트의 상단 기준점
			const bottom = $('.scroll-bottom'); // 스크롤 이벤트의 하단 기준점

			window.addEventListener('scroll', () => {
				const windowScrollTop = $(window).scrollTop(); // 현재 스크롤 위치
				const contentOffsetTop = top.offset().top; // 상단 기준점 위치
				const contentOffsetBottom = bottom.offset().top; // 하단 기준점 위치
				const rightOffsetTop = right.offset().top; // 전체 페이지에서 right 요소의 상단 위치
				scrolledDistance = rightOffsetTop - windowScrollTop;

				// 이미 on 상태일 때 스크롤 진행에 따라 새로운 클래스 추가
				// 하단 기준점에 도달했을 때 on 클래스 제거, end 클래스 추가
				if (contentOffsetBottom <= windowScrollTop + 1140) {
					if (isOn) {
						left.removeClass('on').addClass('end');
						isOn = false; // 상태 갱신
					}
				} else if (contentOffsetTop >= windowScrollTop) {
					// 상단 기준점에 도달했을 때 on 클래스 제거
					if (isOn) {
						left.removeClass('on');
						isOn = false; // 상태 갱신
					}
				} else {
					// 다이어그램이 다시 화면 안에 들어왔을 때 on 클래스 추가, end 클래스 제거
					if (!isOn) {
						left.addClass('on').removeClass('end');
						isOn = true; // 상태 갱신
					}
				}

				// if (scrolledDistance < 550 && scrolledDistance > 450) {
				// 	title.removeClass('item02 item03 item04 item05 item06'); // 이전 클래스 제거
				// 	title.addClass('item01');
				// } else if (scrolledDistance < 450 && scrolledDistance > 350) {
				// 	title.removeClass('item02 item03 item04 item05 item06'); // 이전 클래스 제거
				// 	title.addClass('item02');
				// } else if (scrolledDistance < 350 && scrolledDistance > 200) {
				// 	title.removeClass('item02 item03 item04 item05 item06'); // 이전 클래스 제거
				// 	title.addClass('item03');
				// } else if (scrolledDistance < 200 && scrolledDistance > 150) {
				// 	title.removeClass('item02 item03 item04 item05 item06'); // 이전 클래스 제거
				// 	title.addClass('item04');
				// } else if (scrolledDistance < 150 && scrolledDistance > 100) {
				// 	title.removeClass('item02 item03 item04 item05 item06'); // 이전 클래스 제거
				// 	title.addClass('item05');
				// } else if (scrolledDistance < 100 && scrolledDistance > 0) {
				// 	title.removeClass('item02 item03 item04 item05 item06'); // 이전 클래스 제거
				// 	title.addClass('item06');
				// } else {
				// 	title.removeClass('item01 item02 item03 item04 item05 item06'); // 이전 클래스 제거
				// }
			});
		}
	},

	hashTag: () => {
		const hashtag = $('.tag_wrap .hashtag');
		hashtag.on('click', function () {
			hashtag.removeClass('active');

			$(this).addClass('active');
		});
	},

	countNumber: () => {
		$(".odometer").each(function () {
            const $this = $(this);
            const finalValue = $this.attr("data-odometer-final");

            if (!$this.hasClass("odometer-activated")) {
                const windowHeight = $(window).height();
                const scrollTop = $(window).scrollTop();
                const elementOffset = $this.offset().top;
                
                if (scrollTop + windowHeight > elementOffset) {
                    $this.addClass("odometer-activated");
                    setTimeout(() => {
                        $this.html(finalValue);
                    }, 100);
                }
            }
        });
	},

	privacy: () => {
		const optionCount = $('#privacy-select option').length; // option 요소의 개수

		if (optionCount === 1) {
			$('#privacy-select').on('click', function () {
				const selectedValue = $(this).val(); // 선택된 option의 value 값 가져오기
				window.location.href = selectedValue;
			});
		} else {
			// `select` 요소에 변경 사항이 있을 때도 이벤트가 발생하도록 처리
			$('#privacy-select').on('change', function () {
				const path = $(this).val(); // 선택된 옵션의 value 값 가져오기
				if (path) {
					window.location.href = path; // 페이지 이동
				}
			});
		}
	},

	// 오시는길 서브 탭
	locationTab: () => {
		const tapLists = document.querySelectorAll('.tap_list');
		const tapBoxs = document.querySelectorAll('.tap_box');

		tapLists.forEach(function (tapList, index) {
			tapList.addEventListener('click', function () {
				// .history .tap_list 요소는 클릭 이벤트가 작동하지 않도록 조건 추가
				if (tapList.closest('.history')) {
					return;
				}

				// 탭 활성화 로직
				tapLists.forEach(function (listItem) {
					listItem.classList.remove('active');
				});
				tapList.classList.add('active');

				// 탭 박스 숨김/표시 처리
				tapBoxs.forEach(function (tapBox, boxIndex) {
					if (index === boxIndex) {
						tapBox.classList.remove('hidden');
					} else {
						tapBox.classList.add('hidden');
					}
				});
			});
		});
	},

	// history 탭
	historyTab: () => {
		const tapLists = document.querySelectorAll('.history .tap_list');
		const tapBoxs = document.querySelectorAll('.history .tap_box');

		tapLists.forEach(function (tapList, index) {
			tapList.addEventListener('click', function () {
				tapLists.forEach(function (listItem) {
					listItem.classList.remove('active');
				});
				tapList.classList.add('active');

				tapBoxs.forEach(function (tapBox, boxIndex) {
					if (index === boxIndex) {
						tapBox.classList.remove('invisible');
					} else {
						tapBox.classList.add('invisible');
					}
				});
			});
		});
	},

	// 미션&비전
	missionEvent: () => {
		// 전제조건, 비전
		const item = $('.mission-list li');
		// item.on('mouseover', function () {
		// 	if (window.innerWidth <= 768) return;
		// 	const name = $(this).children().data('name');
		// 	const target = $(this)
		// 		.closest('.mission-list')
		// 		.next('.mission-detail')
		// 		.find('.' + name);
		// 	target.removeClass('hidden').addClass('block');
		// });
		// $('.mission-detail').on('mouseleave', function () {
		// 	$('.mission-item').removeClass('block').addClass('hidden');
		// });
		item.on('click', function () {
			// if (window.innerWidth > 768) return;
			$('body').addClass('layer-opens');
			const name = $(this).children().data('name');
			const target = $(this)
				.closest('.mission-list')
				.next('.mission-detail')
				.find('.' + name);
			target.removeClass('hidden').addClass('block');
		});
		$('.mission-detail .close').on('click', function () {
			$('body').removeClass('layer-opens');
			$(this).closest('.mission-item').removeClass('block').addClass('hidden');
		});
		// 핵심가치
		const item2 = $('.mission-core-list li');
		// item2.on('mouseover', function () {
		// 	if (window.innerWidth <= 1024) return;
		// 	const name = $(this).children().data('name');
		// 	const target = $(this)
		// 		.closest('.mission-core-list')
		// 		.next('.mission-core-detail')
		// 		.find('.' + name);
		// 	target.removeClass('hidden').addClass('block');
		// });
		// $('.mission-core-detail').on('mouseleave', function () {
		// 	$('.mission-core-item').removeClass('block').addClass('hidden');
		// });
		item2.on('click', function () {
			// if (window.innerWidth > 768) return;
			$('body').addClass('layer-opens');
			const name = $(this).children().data('name');
			const target = $(this)
				.closest('.mission-core-list')
				.next('.mission-core-detail')
				.find('.' + name);
			target.removeClass('hidden').addClass('block');
		});
		$('.mission-core-detail .close').on('click', function () {
			$('body').removeClass('layer-opens');
			$(this).closest('.mission-core-item').removeClass('block').addClass('hidden');
		});
	},

	missionWord: () => {
		function titleSplit(target) {
			const title = $(target);
			const string = title.text();
			const delay = 0.03;
			const index = [];
			title.addClass('split');
			return string
				.trim()
				.split('')
				.map(function (word, idx) {
					const remove = word === ',' ? 'remove' : '';
					return '<span class="' + remove + '">' + word + '<em style="transition-delay:' + idx * delay + 's"></em></span>';
				})
				.reduce(function (acc, val) {
					return acc + val;
				}, '');
		}

		const desc = $('.text-strong');
		if (!desc.hasClass('split')) desc.html(titleSplit(desc));
		setTimeout(function () {
			desc.addClass('active');
		}, 300);
	},

	// 신재생에너지 탭
	renewableEvent: () => {
		const tab = $('.renewable .tab-button-wrap button');
		const dot = $('.dot');

		tab.on('click', function () {
			const index = $(this).index();

			$('.tab-button-wrap button').removeClass('on');
			$('.tab-contents').removeClass('on');

			// 클릭된 탭과 해당 콘텐츠에 active 클래스 추가
			$(this).addClass('on');
			$('.tab-contents').eq(index).addClass('on');
			dot.removeClass('active');
			if (index === 0) {
				$('.con2').addClass('active');
			} else if (index === 1) {
				$('.con1').addClass('active');
			}
		});
	},

	// 책임광물보고서 탭
	responsibleMineralsTab: () => {
		const tapLists = document.querySelectorAll('.responsible_minerals .tap_list');
		const tapBoxs = document.querySelectorAll('.responsible_minerals .tap_box');

		tapLists.forEach((tapList, index) => {
			tapList.addEventListener('click', () => {
				tapLists.forEach((listItem) => {
					listItem.classList.remove('active');
				});

				tapList.classList.add('active');

				tapBoxs.forEach((tapBox) => {
					tapBox.classList.add('invisible');
				});

				tapBoxs[index].classList.remove('invisible');
			});
		});
	},
	
	// 히스토리월
	historyWallScroll: () => {
		const el = $('.history-wall .bg-image');
		el.each(function () {
			const top = $(this).offset().top;
			const scrollTop = $(window).scrollTop();
			const windowHeight = $(window).height();
			const documentHeight = $(document).height();
			if (scrollTop > top - (windowHeight - windowHeight * 0.2)) {
				$(this).addClass('is-active');
			}
		});
	},
	historyWall: () => {
		sub.historyWallScroll();
		$(window).on('scroll', function () {
			sub.historyWallScroll();
		});
	},
	historyLayer: () => {
		const btn = $('.js-btn-history');
		const layer = $('.history-layer');
		const close = layer.find('.close');
		btn.on('click', function() {
			const index = $(this).data('index');
			const layer = $('.history-layer');
			if( layer.hasClass('hidden')) {
				layer.removeClass('hidden').addClass('open');
				$('body').addClass('layer-opens');
			}
			const sideButton = layer.find('.side .btn_area' + index);
			sideButton.addClass('on').siblings().removeClass('on');
			const contents = layer.find('.contents .list-' + index);
			contents.addClass('on').siblings().removeClass('on');
			setTimeout(() => {
				layer.find('.contents').animate({scrollTop: 0}, 200);
			}, 50)

			if( index === 4 && window.innerWidth < 490 ) {
				const side = $('.side');
				side.animate({
					scrollLeft: side[0].scrollWidth - side.outerWidth()
				}, 0);
			}
		});
		close.on('click', function() {
			layer.removeClass('open').addClass('hidden');
			$('body').removeClass('layer-opens');
		});
	},

	init: () => {
		sub.networkToggle();
		sub.networkOverseas();
		sub.toggleBtn();
		sub.fileUpload();
		sub.emailSelect();
		sub.tabNav();
		sub.accordion();
		sub.video();
		sub.copperScroll();
		sub.hashTag();
		sub.passwordToggle();
		sub.privacy();
		sub.locationTab();
		sub.renewableEvent();
		sub.missionEvent();
		sub.historyTab();
		sub.responsibleMineralsTab();
		sub.countNumber();
		sub.historyWall();
		sub.historyLayer();

		if ($('.mission-intro').length > 0) {
			sub.missionWord();
		}

		$(window).on("scroll", function () {
			sub.countNumber();
		});
	},
};

export { sub };
